<template>
  <div class="tab-text" v-if="basicForm != null && event != null">
    <section>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Poster</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Landscape artwork with recommended size of 1,200x630px (similar to
            that of Facebook's Post)
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <div v-if="event.has_poster">
            <img
              :src="event.poster"
              :width="imageWidth"
              :height="imageHeight"
            />
          </div>
          <div
            v-else
            class="default-upload"
            style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
          >
            <vs-button
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
              color="dark"
              type="border"
              @click="chooseImage()"
            >
              <span>Upload</span>
            </vs-button>
          </div>
          <div
            class="grid-button-upload"
            style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
          >
            <!-- secondary / border  >> btn-->
            <vs-button
              v-if="event.has_poster"
              color="dark"
              type="border"
              icon="autorenew"
              style="display: flex"
              @click="chooseImage()"
            >
              <span>Change</span>
            </vs-button>
            <input
              id="file-upload-img"
              @change="onUploadImages()"
              type="file"
              ref="fileImage"
              :accept="acceptFile"
            />
            <vs-button
              v-if="event.has_poster"
              color="dark"
              type="border"
              icon="delete_forever"
              style="display: flex"
              @click="popupActivo = true"
            >
              Remove
            </vs-button>
            <vs-popup
              classContent="popup-confirm"
              title="Confirm Delete"
              :active.sync="popupActivo"
            >
              <div>Are you sure you want to delete the image?</div>
              <div class="wrap-button">
                <vs-button
                  color="dark"
                  type="border"
                  style="font-size: 12px !important;"
                  @click="popupActivo = false"
                >
                  No
                </vs-button>
                <vs-button
                  color="primary"
                  style="font-size: 12px !important;"
                  @click="removeposter"
                >
                  Yes
                </vs-button>
              </div>
            </vs-popup>
          </div>
          <!-- <div v-else>
					<img
						:src="event.poster"
						:width="imageWidth"
						:height="imageHeight"
					/>
					<vs-button
						color="secondary"
						type="border"
						icon="cloud_done"
						style="display: flex"
						@click="chooseImage()"
					>
						Upload
					</vs-button>
					<input
						id="file-upload-img"
						@change="onUploadImages()"
						type="file"
						ref="fileImage"
						:accept="acceptFile"
					>
				</div> -->
          <!-- <vs-upload
				v-if="!event.poster || changeImage"
				:multiple="false"
				:automatic="true"
				:single-upload="true"
				:action="posterUploadUrl"
				:fileName="`file`"
				:limit="1"
				:data="posterData"
				:headers="posterUploadHeader"
				@on-success="successPosterUpload"
				@on-error="errorPosterUpload"
				accept="image/png, image/jpeg, image/jpg, image/webp"
				/> -->
          <!-- <div
					class="grid-button-upload"
					v-if="event.poster != null"
				>
					<vs-button
						color="dark"
						type="flat"
						icon="autorenew"
						style="display: flex"
						@click="chooseImage()"
					>
						Change
					</vs-button>
					<input
						id="file-upload-img"
						@change="onUploadImages()"
						type="file"
						ref="fileImage"
						:accept="acceptFile"
					>
					<vs-button
						color="dark"
						type="flat"
						icon="delete_forever"
						style="display: flex"
						@click="removeposter"
					>
						Remove
					</vs-button>
				</div> -->
        </div>
      </div>

      <div
        class="vx-row mb-6"
        v-if="
          eventFieldsPermission.find(x => x.key == `pro_name`) &&
            eventFieldsPermission
              .find(x => x.key == `pro_name`)
              .actions.find(x => x.type == `view`)
              .roles.includes(role)
        "
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="{
              required: true
            }"
            name="pro_name"
            class="w-full"
            v-model="basicForm.pro_name"
            v-if="
              eventFieldsPermission
                .find(x => x.key == `pro_name`)
                .actions.find(x => x.type == `edit`)
                .roles.includes(role)
            "
          />
          <span v-else>{{ basicForm.pro_name }}</span>
          <span class="text-danger text-sm" v-show="errors.has('pro_name')">
            {{ splitError(errors.first("pro_name"), "pro_name") }}
          </span>
        </div>
      </div>

      <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Short Name</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="{
                required: true
              }"
              name="pro_shortname"
              class="w-full"
              v-model="basicForm.pro_shortname"
            />
            <span class="text-danger text-sm" v-show="errors.has('pro_shortname')">
              {{ splitError(errors.first("pro_shortname"), 'pro_shortname') }}
            </span>
          </div>
        </div> -->

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>URL</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template v-if="!isEditSlug">
            https://{{ event.merchant.domain }}/{{ basicForm.slug }}
            <vs-button
              @click="isEditSlug = !isEditSlug"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-edit"
              style="display: inline-block"
            ></vs-button>
          </template>
          <template v-else>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              style="margin-bottom: 10px;"
            >
              <span style="margin-right: 8px;"
                >https://{{ event.merchant.domain }}/</span
              >
              <vs-input
                v-validate="{
                  required: true
                }"
                name="slug"
                class="w-full"
                v-model="basicForm.slug"
                v-on:keyup="validateSlug()"
              />
              <span class="text-danger text-sm" v-show="errors.has('slug')">
                {{ splitError(errors.first("slug"), "slug") }}
              </span>
            </vs-col>
            <div class="mt-2 text-right">
              <vs-button @click="submitChangeSlug()" color="primary">
                Submit
              </vs-button>
            </div>
          </template>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="role == 'so-admin'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Type</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <b-form-select
            v-model="basicForm.pro_type"
            :options="proTypeList"
          ></b-form-select>
        </div>
      </div>

      <div class="vx-row mb-6" style="min-height: 150px; margin-top: 0px">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Intro Text</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Shown on the Register page
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- :style="{ height: '100px' }" //quill -->
          <!-- <quill-editor
                class="editor"
                ref="introEditor"
                v-model="basicForm.intro"
                :options="introOptionOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
              > -->
          <!-- <div id="toolbar-8" slot="toolbar">
                  <button class="ql-align" value=""></button>
                  <button class="ql-align" value="center"></button>
                  <button class="ql-align" value="right"></button>
                  <button class="ql-align" value="justify"></button>
                  <button class="ql-link">Link</button>
                  <button class="ql-bold">Bold</button>
                  <button class="ql-italic">Italic</button>
                  <select class="ql-size">
                    <option value="small"></option>
                    <option selected></option>
                    <option value="large"></option>
                    <option value="huge"></option>
                  </select>
                  <button class="ql-script" value="sub"></button>
                  <button class="ql-script" value="super"></button>
                </div> -->
          <!-- </quill-editor> -->
          <ArticleEditor
            v-model="basicForm.intro"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <vs-textarea
            style="display: none"
            class="w-full"
            v-model="basicForm.intro"
          />
          <!-- <vs-button
              @click="onHTMLDialog('intro')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
          <!-- <span @click="onHTMLDialog('intro')">Intro Text</span> -->
        </div>
      </div>

      <div class="vx-row mb-6" style="min-height: 150px">
        <div class="vx-col sm:w-1/3 w-full">
          <!-- <span @click="onHTMLDialog('shortdesc')">Short Description</span> -->
          <span>Short Description</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- :style="{ minHeight: '62px', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '6px', marginBottom: '16px' }" -->
          <!-- <quill-editor
              :style="{ height: '100px' }"
              class="editor"
              ref="shortdescEditor"
              v-model="basicForm.shortdesc"
              :content="basicForm.shortdesc"
              :options="editorShortOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            /> -->
          <!-- <quill-editor
              class="editor"
              ref="introEditor"
              v-model="basicForm.shortdesc"
              :options="shortdescOptionOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            > -->
          <!-- <div id="toolbar-8" slot="toolbar">
                <button class="ql-align" value=""></button>
                <button class="ql-align" value="center"></button>
                <button class="ql-align" value="right"></button>
                <button class="ql-align" value="justify"></button>
                <button class="ql-link">Link</button>
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <select class="ql-size">
                  <option value="small"></option>
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </div> -->
          <!-- </quill-editor> -->
          <ArticleEditor
            v-model="basicForm.shortdesc"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <vs-textarea
            style="display: none"
            class="w-full"
            v-model="basicForm.shortdesc"
          />
          <!-- <vs-button
              @click="onHTMLDialog('shortdesc')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>

      <div class="vx-row mb-6" style="min-height: 150px">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Long Description</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
          <!-- <vs-button size="small" class="mr-3 mb-2" type="border"
						>HTML
						</vs-button> -->
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- :style="{ minHeight: '62px', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '6px', marginBottom: '16px' }" -->
          <!--:style="{ height: '100px' }" //quill  -->
          <!-- <quill-editor
              class="editor"
              ref="editorLongOption"
              v-model="basicForm.longdesc"
              :content="basicForm.longdesc"
              :options="editorLongOption"
              @change="onEditorChange($event)"
            /> -->
          <ArticleEditor
            v-model="basicForm.longdesc"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <!-- <vs-textarea
              style="display: block"
              class="w-full"
              v-model="basicForm.longdesc"
            /> -->
          <!-- <vs-button
              @click="onHTMLDialog('longdesc')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Date</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <el-date-picker
            v-validate="'required'"
            name="daterange"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm"
            format="dd-MM-yyyy HH:mm"
            v-model="basicForm.daterange"
            type="datetimerange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            popper-class="custom-date-picker"
          ></el-date-picker>
          <span class="text-danger text-sm" v-show="errors.has('daterange')">
            {{ splitError(errors.first("daterange"), "daterange") }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Timezone</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <b-form-select
            v-model="basicForm.timezone"
            :options="timezones"
          ></b-form-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Venue</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="venue"
            class="w-full"
            v-model="basicForm.venue"
            placeholder="Eg., Singapore EXPO, Atrium 4"
          />
          <span class="text-danger text-sm" v-show="errors.has('venue')">
            {{ splitError(errors.first("venue"), "venue") }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6" v-show="false">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Type of Event</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio v-model="basicForm.mode" vs-value="standard">
                Offline
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="basicForm.mode" vs-value="online">
                Online
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="basicForm.mode" vs-value="conference">
                Conference
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Is this a Free event?</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                v-model="basicForm.freeevent"
                vs-name="radios-freeevent"
                :vs-value="1"
              >
                Yes
              </vs-radio>
            </li>
            <li>
              <vs-radio
                v-model="basicForm.freeevent"
                vs-name="radios-freeevent"
                :vs-value="0"
              >
                No
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Privacy</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul>
            <li class="my-2">
              <vs-radio v-model="basicForm.privacy" vs-value="public">
                Public
                <span style="font-size: 0.75rem; color: #aaa">
                  - Anyone with the link can see the registration page
                </span>
              </vs-radio>
            </li>
            <li class="my-2">
              <vs-radio v-model="basicForm.privacy" vs-value="unlisted">
                Unlisted
                <span style="font-size: 0.75rem; color: #aaa">
                  - The registration page will be hidden
                </span>
              </vs-radio>
            </li>
            <li class="my-2">
              <vs-radio v-model="basicForm.privacy" vs-value="invite-only">
                Invite Only
                <span style="font-size: 0.75rem; color: #aaa">
                  - Only those with invite code will be able to see the
                  registration page
                </span>
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>
      <div class="vx-row mb-6" v-if="basicForm.privacy == 'invite-only'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Invite Code</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            placeholder="Enter Code"
            v-model="basicForm.private_token"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registration Status</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                v-model="basicForm.sell_status"
                vs-name="radios-sell_status"
                :vs-value="`open`"
              >
                Open
              </vs-radio>
            </li>
            <li>
              <vs-radio
                v-model="basicForm.sell_status"
                vs-name="radios-sell_status"
                :vs-value="`closed`"
              >
                Closed
              </vs-radio>
            </li>
            <li>
              <vs-radio
                v-model="basicForm.sell_status"
                vs-name="radios-sell_status"
                :vs-value="`soldoutt`"
              >
                SOLDOUTT
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registration Period</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <el-date-picker
            v-validate="'required'"
            name="selldaterange"
            style="width: 100%"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm"
            format="dd-MM-yyyy HH:mm"
            v-model="basicForm.selldaterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selldaterange')"
          >
            {{ splitError(errors.first("selldaterange"), "selldaterange") }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="role == 'so-admin'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Put New Registrant on Waitlist</span>
          <div style="font-size: 0.75rem; color: #aaa">
            If enabled, new registrations will be put on a waitlist and will
            receive a ticket only when approved.
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-waitlist"
                v-model="basicForm.waitlist"
                :vs-value="1"
              >
                Yes
              </vs-radio>
            </li>
            <li>
              <vs-radio
                vs-name="radios-waitlist"
                v-model="basicForm.waitlist"
                :vs-value="0"
              >
                No
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6" style="min-height: 150px">
        <div class="vx-col sm:w-1/3 w-full">
          <!-- <span @click="onHTMLDialog('instruction')">Instruction</span> -->
          <span>Instruction</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Shown on the Thank You page after completing the registration and in
            the ticket email received by attendees
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- :style="{ minHeight: '62px', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '6px', marginBottom: '16px' }" -->
          <!-- <quill-editor
              class="editor"
              ref="instructionEditor"
              v-model="basicForm.instruction"
              :content="basicForm.instruction"
              :options="editorInstructionOption"
              @change="onEditorChange($event)"
            /> -->
          <!-- {{ basicForm.instruction }} -->
          <ArticleEditor
            v-if="!htmlDialog"
            v-model="basicForm.instruction"
            :clean="true"
            :config="{
              css: '/article-editor/css/',
              format: [
                'div',
                'p',
                'h2',
                'h3',
                'center',
                'strong',
                'b',
                'i',
                'em',
                'a'
              ],
              editor: {
                focus: false
              },
              toolbar: {
                hide: ['add']
              },
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <!-- {{ basicForm.instruction }} -->
          <!-- <textarea v-model="basicForm.instruction"></textarea> -->
          <!-- <vs-button
              @click="onHTMLDialog('instruction', true)"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>

      <div class="vx-row mb-6" style="min-height: 150px; margin-top: 0px">
        <div class="vx-col sm:w-1/3 w-full">
          <!-- <span @click="onHTMLDialog('lobby_intro')">Lobby Intro</span> -->
          <span>Lobby Intro</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Shown on the Lobby page before entering the live session
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- :style="{ minHeight: '62px', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '6px', marginBottom: '16px' }" -->
          <!-- <quill-editor
              class="editor"
              ref="lobbyEditor"
              v-model="basicForm.lobby_intro"
              :content="basicForm.lobby_intro"
              :options="lobbyIntroOption"
              @change="onEditorChange($event)"
            /> -->
          <ArticleEditor
            v-model="basicForm.lobby_intro"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <!-- <vs-textarea
              style="display: block"
              class="w-full"
              v-model="basicForm.lobby_intro"
            /> -->
          <!-- <vs-button
              @click="onHTMLDialog('lobby_intro')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Event Landing Page URL</span>
          <div style="font-size: 0.75rem; color: #aaa">
            If provided, this URL will be the shared URL instead of the Register
            page when attendees share the event with their friends
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="basicForm.landingpage" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Featured</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Pin this event at the top of the list
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-featured_status"
                v-model="basicForm.featured_status"
                :vs-value="1"
              >
                Yes
              </vs-radio>
            </li>
            <li>
              <vs-radio
                vs-name="radios-featured_status"
                v-model="basicForm.featured_status"
                :vs-value="0"
              >
                No
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="role == 'so-admin'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Status</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-publish_status"
                v-model="basicForm.publish_status"
                vs-value="1"
              >
                Enabled
              </vs-radio>
            </li>
            <li>
              <vs-radio
                vs-name="radios-publish_status"
                v-model="basicForm.publish_status"
                vs-value="0"
              >
                Disabled
              </vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="vx-row mb-6"
        v-if="basicForm.privacy == 'invite-only' && false"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Invite Code</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="basicForm.private_token" />
        </div>
      </div>
    </section>

    <hr />

    <!-- Currency Card -->
    <section>
      <template v-if="basicForm.freeevent == 0">
        <section>
          <h1 class="py-5 card-title">Currency</h1>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Currency</span>
              <div style="font-size: 0.75rem; color: #aaa">
                The ticket currency to be displayed
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <b-form-select
                v-validate="{ required: true }"
                name="currency"
                v-model="basicForm.currency"
                :options="currencyList"
              ></b-form-select>
              <span class="text-danger text-sm" v-show="errors.has('currency')">
                {{ splitError(errors.first("currency"), "currency") }}
              </span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Has Reference Currency?</span>
              <div style="font-size: 0.75rem; color: #aaa">
                Other currency to be shown as comparison
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="checkRefForm" :vs-value="1">Yes</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="checkRefForm" :vs-value="0">No</vs-radio>
                </li>
              </ul>
            </div>
          </div>
          <template v-if="checkRefForm === 1">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Reference Currency</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <b-form-select
                  v-validate="{ required: this.checkRefForm === 1 }"
                  name="altcurrencycode"
                  v-model="basicForm.altcurrencycode"
                  :options="currencyList"
                ></b-form-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('altcurrencycode')"
                >
                  {{
                    splitError(
                      errors.first("altcurrencycode"),
                      "altcurrencycode"
                    )
                  }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Exchange Rate</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="{ required: this.checkRefForm === 1 }"
                  name="altcurrencyrate"
                  placeholder="32.10"
                  class="w-full"
                  v-model="basicForm.altcurrencyrate"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('altcurrencyrate')"
                >
                  {{
                    splitError(
                      errors.first("altcurrencyrate"),
                      "altcurrencyrate"
                    )
                  }}
                </span>
              </div>
            </div>
          </template>
        </section>
      </template>
    </section>

    <hr />
    <!-- Terms & Policies -->
    <section>
      <h1 class="py-5">Terms & Policies</h1>

      <div class="vx-row mb-6" v-if="role == 'so-admin'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Allow Refunds</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-norefund"
                v-model="basicForm.norefund"
                :vs-value="1"
                >Yes</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-norefund"
                v-model="basicForm.norefund"
                :vs-value="0"
                >No</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <div
        class="vx-row mb-6"
        style="min-height: 150px"
        v-if="basicForm.norefund == 1"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Refund Policy</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- <quill-editor
              class="editor"
              ref="refundpolicyEditor"
              v-model="basicForm.refundpolicy"
              :options="refundpolicyOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            > -->
          <!-- <div id="toolbar-9" slot="toolbar">
                <button class="ql-align" value=""></button>
                <button class="ql-align" value="center"></button>
                <button class="ql-align" value="right"></button>
                <button class="ql-align" value="justify"></button>
                <button class="ql-link">Link</button>
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <select class="ql-size">
                  <option value="small"></option>
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <select class="ql-font">
                  <option selected="selected"></option>
                  <option value="serif"></option>
                  <option value="monospace"></option>
                </select>
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </div> -->
          <!-- </quill-editor> -->
          <ArticleEditor
            v-model="basicForm.refundpolicy"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <!-- <vs-textarea
              style="display: none"
              class="w-full"
              v-model="basicForm.refundpolicy"
            /> -->
          <!-- <vs-button
              @click="onHTMLDialog('refundpolicy')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>

      <div
        class="vx-row mb-6"
        v-if="basicForm.freeevent == 0 && role == 'so-admin'"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Allow Ticket Transfers</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Make tickets transferable to another attendee
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-ticketTransfer"
                v-model="basicForm.tickettransfer"
                :vs-value="1"
                >Yes</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-ticketTransfer"
                v-model="basicForm.tickettransfer"
                :vs-value="0"
                >No</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6" style="min-height: 150px">
        <div class="vx-col sm:w-1/3 w-full">
          <!-- <span @click="onHTMLDialog('terms')">Terms and Condition</span> -->
          <span>Terms and Condition</span>
          <div style="font-size: 0.75rem; color: #aaa">
            We recommend putting important terms and conditions and privacy
            policy here
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- {{ basicForm.terms }} -->
          <!-- <quill-editor
              class="editor"
              ref="termsEditor"
              v-model="basicForm.terms"
              :options="termsIntroOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            >
            </quill-editor> -->

          <ArticleEditor
            v-model="basicForm.terms"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <!-- <div id="toolbar-5" slot="toolbar">
                <button class="ql-align" value=""></button>
                <button class="ql-align" value="center"></button>
                <button class="ql-align" value="right"></button>
                <button class="ql-align" value="justify"></button>
                <button class="ql-link">Link</button>
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <select class="ql-size">
                  <option value="small"></option>
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <select class="ql-font">
                  <option selected="selected"></option>
                  <option value="serif"></option>
                  <option value="monospace"></option>
                </select>
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </div> -->
          <!-- <vs-button
              @click="onHTMLDialog('terms')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>

      <div class="vx-row mb-6" v-if="role == 'so-admin'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Require Terms Acceptance</span>
          <div style="font-size: 0.75rem; color: #aaa">
            If enabled, registrants will be required to check the Terms checkbox
            before submitting the registration information
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-terms_require"
                v-model="basicForm.terms_require"
                vs-value="1"
                >On</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-terms_require"
                v-model="basicForm.terms_require"
                vs-value="0"
                >Off</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section v-show="false">
      <h1 class="py-5">Info</h1>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Event Landing Page URL</span>
          <div style="font-size: 0.75rem; color: #aaa">
            If provided, this URL will be the shared URL instead of the Register
            page when attendees share the event with their friends
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="basicForm.join_url" />
        </div>
      </div>
    </section>

    <hr />

    <section v-if="role == 'so-admin'">
      <h1 class="py-5">Withholding Tax & Tax Invoice</h1>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Withholding Tax Deduction</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Allows buyers to request Withholding Tax deductions (applicable for
            orders valued 1000 Baht and above)
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-wht_status"
                v-model="basicForm.wht_status"
                :vs-value="1"
                >On</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-wht_status"
                v-model="basicForm.wht_status"
                :vs-value="0"
                >Off</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6" v-show="basicForm.wht_status == 1">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Deduction Percentage</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Deduction percentage
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="{ max_value: 100, min_value: 0.1 }"
            name="percentTax"
            class="w-full"
            v-model="basicForm.wht_vat"
            onkeypress="return /^[0-9.]/i.test(event.key)"
          />
          <span class="text-danger text-sm" v-show="errors.has('percentTax')">
            {{ splitError(errors.first("percentTax"), "percentTax") }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6" v-show="basicForm.wht_status == 1">
        <div class="vx-col sm:w-1/3 w-full">
          <span>When to apply the deduction</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-wht_later"
                v-model="basicForm.wht_later"
                :vs-value="1"
                >Buyer pays in full and submits the document to claim the
                deduction later</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-wht_later"
                v-model="basicForm.wht_later"
                :vs-value="0"
                >Right away, buyer pays the amount after deduction</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <template v-if="basicForm.wht_status == 1">
        <div class="vx-row mb-6" style="min-height: 150px">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Tax Invoice Instruction</span>
            <div style="font-size: 0.75rem; color: #aaa">
              Provide next step instructions for buyers who requested for tax
              invoice and/or the company name and address for issuing and
              sending the Withholding Tax
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <!-- <quill-editor
                class="editor"
                ref="taxInvoiceInstEditor"
                v-model="basicForm.taxinv_instruction"
                :options="taxInvoiceInstOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
              > -->
            <!-- <div id="toolbar-7" slot="toolbar">
                  <button class="ql-align" value=""></button>
                  <button class="ql-align" value="center"></button>
                  <button class="ql-align" value="right"></button>
                  <button class="ql-align" value="justify"></button>
                  <button class="ql-link">Link</button>
                  <button class="ql-bold">Bold</button>
                  <button class="ql-italic">Italic</button>
                  <select class="ql-size">
                    <option value="small"></option>
                    <option selected></option>
                    <option value="large"></option>
                    <option value="huge"></option>
                  </select>
                  <select class="ql-font">
                    <option selected="selected"></option>
                    <option value="serif"></option>
                    <option value="monospace"></option>
                  </select>
                  <button class="ql-script" value="sub"></button>
                  <button class="ql-script" value="super"></button>
                </div> -->
            <!-- </quill-editor> -->
            <ArticleEditor
              v-model="basicForm.taxinv_instruction"
              :config="{
                plugins: ['blockcode'],
                addbarAdd: ['text', 'card'],
                css: '/article-editor/css/',
                format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                align: {
                  left: 'text-left',
                  center: 'text-center',
                  right: 'text-right',
                  justify: 'text-justify'
                }
              }"
            ></ArticleEditor>
            <vs-textarea
              style="display: none"
              class="w-full"
              v-model="basicForm.taxinv_instruction"
            />
            <!-- <vs-button
              @click="onHTMLDialog('taxinv_instruction')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
          </div>
        </div>
      </template>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Allow Tax Invoice requests</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Allow customers to request for Tax Invoice by submitting their
            details
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-taxinv_status"
                v-model="basicForm.taxinv_status"
                :vs-value="1"
                >Yes</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-taxinv_status"
                v-model="basicForm.taxinv_status"
                :vs-value="0"
                >No</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Automatically issue Tax Invoice</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Tax Invoice will be sent to the buyer's email automatically once the
            payment is confirmed
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-digitalinvoice"
                v-model="basicForm.digitalinvoice"
                :vs-value="1"
                >Enabled</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-digitalinvoice"
                v-model="basicForm.digitalinvoice"
                :vs-value="0"
                >Disabled</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6" v-show="basicForm.digitalinvoice == 1">
        <div class="vx-col sm:w-1/3 w-full">
          <span>When to issue</span>
          <div style="font-size: 0.75rem; color: #aaa">
            If issued only to specific buyers, the document no. is incremented
            only for the issued Tax Invoices. Not recommended to change this
            once the sale has begun.
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-taxinv_onrequest"
                v-model="basicForm.taxinv_onrequest"
                :vs-value="0"
                >All Orders</vs-radio
              >
            </li>
            <li>
              <vs-radio
                vs-name="radios-taxinv_onrequest"
                v-model="basicForm.taxinv_onrequest"
                :vs-value="1"
                >Only if the Buyer requests for it</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mb-6" v-show="basicForm.digitalinvoice == 1">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Document No. Prefix</span>
          <div style="font-size: 0.75rem; color: #aaa"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="{ regex: /^([0-9A-Z-]+)$/ }"
            :maxLength="5"
            name="taxinv_prefix"
            class="w-full"
            v-model="basicForm.taxinv_prefix"
            onkeypress="return /^[0-9A-Z-]/i.test(event.key)"
            onpaste="return false"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('taxinv_prefix')"
          >
            {{ splitError(errors.first("taxinv_prefix"), "taxinv_prefix") }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6" v-show="basicForm.digitalinvoice == 1">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Signature</span>
          <div style="font-size: 0.75rem; color: #aaa">
            PNG file with transparent background. Recommend size: 600x300px
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <div v-if="basicForm.taxinv_sign != null || signature != null">
            <img
              v-if="signature"
              :src="signature"
              style="width:auto;height: 60px"
            />
            <img
              v-else
              :src="basicForm.taxinv_sign"
              style="width:auto;height: 60px"
            />
          </div>
          <div
            v-if="!basicForm.taxinv_sign"
            class="default-upload"
            style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
          >
            <vs-button
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
              color="dark"
              type="border"
              @click="chooseSignature()"
            >
              <span>Upload</span>
            </vs-button>
          </div>
          <div
            class="grid-button-upload"
            style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
          >
            <!-- secondary / border  >> btn-->
            <vs-button
              v-if="basicForm.taxinv_sign"
              color="dark"
              type="border"
              icon="autorenew"
              style="display: flex"
              @click="chooseSignature()"
            >
              <span>Change</span>
            </vs-button>
            <input
              id="file-upload-img-signature"
              @change="onUploadSignature()"
              type="file"
              ref="fileImageSignature"
              :accept="acceptFile"
            />
            <vs-button
              v-if="basicForm.taxinv_sign"
              color="dark"
              type="border"
              icon="delete_forever"
              style="display: flex"
              @click="popupActivo2 = true"
            >
              Remove
            </vs-button>
            <vs-popup
              classContent="popup-confirm"
              title="Confirm Delete"
              :active.sync="popupActivo2"
            >
              <div>Are you sure you want to delete the image?</div>
              <div class="wrap-button">
                <vs-button
                  color="dark"
                  type="border"
                  style="font-size: 12px !important;"
                  @click="popupActivo2 = false"
                >
                  No
                </vs-button>
                <vs-button
                  color="primary"
                  style="font-size: 12px !important;"
                  @click="removeSignature"
                >
                  Yes
                </vs-button>
              </div>
            </vs-popup>
          </div>

          <!-- <vs-upload
					:multiple="false"
					:automatic="true"
					:single-upload="true"
					:action="posterUploadUrl"
					:fileName="`file`"
					:limit="1"
					:data="signatureData"
					:headers="posterUploadHeader"
					@on-success="successPosterUpload"
					accept="image/png, image/jpeg, image/jpg, image/webp"
				/> -->
        </div>
      </div>

      <div class="vx-row mb-6" v-show="basicForm.digitalinvoice == 1">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Accounting's Contact No.</span>
          <div style="font-size: 0.75rem; color: #aaa">
            In case a buyer needs to contact the accounting team
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="basicForm.taxinv_supportno" />
        </div>
      </div>

      <template v-if="basicForm.taxinv_status == 1 && false">
        <div class="vx-row mb-6" style="min-height: 150px">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Instruction</span>
            <div style="font-size: 0.75rem; color: #aaa">
              Shown on the Thank You page after completing the registration and
              in the ticket email received by attendees
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <!-- <quill-editor
                class="editor"
                ref="taxInvoiceInstEditor"
                v-model="basicForm.taxinv_instruction"
                :options="taxInvoiceInstOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
              > -->
            <!-- <div id="toolbar-7" slot="toolbar">
                  <button class="ql-align" value=""></button>
                  <button class="ql-align" value="center"></button>
                  <button class="ql-align" value="right"></button>
                  <button class="ql-align" value="justify"></button>
                  <button class="ql-link">Link</button>
                  <button class="ql-bold">Bold</button>
                  <button class="ql-italic">Italic</button>
                  <select class="ql-size">
                    <option value="small"></option>
                    <option selected></option>
                    <option value="large"></option>
                    <option value="huge"></option>
                  </select>
                  <select class="ql-font">
                    <option selected="selected"></option>
                    <option value="serif"></option>
                    <option value="monospace"></option>
                  </select>
                  <button class="ql-script" value="sub"></button>
                  <button class="ql-script" value="super"></button>
                </div> -->
            <!-- </quill-editor> -->
            <ArticleEditor
              v-model="basicForm.taxinv_instruction"
              :config="{
                plugins: ['blockcode'],
                addbarAdd: ['text', 'card'],
                css: '/article-editor/css/',
                format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                align: {
                  left: 'text-left',
                  center: 'text-center',
                  right: 'text-right',
                  justify: 'text-justify'
                }
              }"
            ></ArticleEditor>
            <vs-textarea
              style="display: none"
              class="w-full"
              v-model="basicForm.taxinv_instruction"
            />
            <!-- <vs-button
              @click="onHTMLDialog('taxinv_instruction')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
          </div>
        </div>
      </template>

      <div
        class="vx-row mb-6"
        style="min-height: 150px"
        v-if="role == 'so-admin' && false"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Invite Text</span>
          <div style="font-size: 0.75rem; color: #aaa">
            Allow ticket holders to invite other friends by sharing a link from
            their ticket email
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <!-- <quill-editor
              class="editor"
              ref="inviteTextEditor"
              v-model="basicForm.invitetext"
              :options="inviteTextOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            > -->
          <!-- <div id="toolbar-6" slot="toolbar">
                <button class="ql-align" value=""></button>
                <button class="ql-align" value="center"></button>
                <button class="ql-align" value="right"></button>
                <button class="ql-align" value="justify"></button>
                <button class="ql-link">Link</button>
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <select class="ql-size">
                  <option value="small"></option>
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <select class="ql-font">
                  <option selected="selected"></option>
                  <option value="serif"></option>
                  <option value="monospace"></option>
                </select>
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </div> -->
          <!-- </quill-editor> -->
          <ArticleEditor
            v-model="basicForm.invitetext"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
          <vs-textarea
            style="display: none"
            class="w-full"
            v-model="basicForm.invitetext"
          />
          <!-- <vs-button
              @click="onHTMLDialog('inviteText')"
              class="html-btn"
            >
              Edit Html
            </vs-button> -->
        </div>
      </div>
    </section>

    <hr />

    <!-- Related Items Card -->
    <section>
      <template>
        <section>
          <h1 class="py-5 card-title">Related Items</h1>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Related Events</span>
              <div style="font-size: 0.75rem; color: #aaa">
                These events will be recommended when viewing the event
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div v-if="is_event_loaded">
                <!-- <v-select
                  v-model="related_event_ids_input"
                  :options="related_event_ids_options"
                  multiple
                ></v-select> -->
                <v-select
                  class="hide-select-action"
                  v-model="related_event_ids_search"
                  :options="relatedEventSearchOptions"
                  @input="onAddEventRelated"
                  placeholder="Search Event"
                ></v-select>
                <div class="px-1 mt-4">
                  <draggable
                    v-model="related_event_ids_input"
                    tag="div"
                    class="row"
                  >
                    <div
                      class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                      v-for="(item, index) in related_event_ids_input"
                      :key="index"
                    >
                      <vs-card class="position-relative">
                        <div class="close-btn" @click="removeRelatedEvent(item.value)">
                          <i class="fas fa-times-circle"></i>
                        </div>
                        <div class="">
                          <img :src="item.poster" class="img-fluid" alt="">
                        </div>
                        <div class="mt-2 overflow-hidden">{{ item.label }}</div>
                      </vs-card>
                    </div>
                  </draggable>
                </div>
              </div>
              <v-select
                v-else
                class="hide-select-action"
                disabled
                placeholder="Loading..."
              ></v-select>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Related Products</span>
              <div style="font-size: 0.75rem; color: #aaa">
                These products will be recommended when viewing the event
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <!-- <v-select
                v-model="related_product_ids_input"
                :options="related_product_ids_options"
                multiple
              ></v-select> -->
              <v-select
                class="hide-select-action"
                v-model="related_product_ids_search"
                :options="relatedProductSearchOptions"
                @input="onAddProductRelated"
                placeholder="Search Product"
              ></v-select>
              <div class="px-1 mt-2">
                <draggable
                  v-model="related_product_ids_input"
                  tag="div"
                  class="row"
                >
                  <div
                    class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                    v-for="(item, index) in related_product_ids_input"
                    :key="index"
                  >
                    <vs-card class="position-relative">
                      <div class="close-btn" @click="removeRelatedProduct(item.value)">
                        <i class="fas fa-times-circle"></i>
                      </div>
                      <div class="">
                        <img :src="item.poster" class="img-fluid" alt="">
                      </div>
                      <div class="mt-2 overflow-hidden">{{ item.label }}</div>
                    </vs-card>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Keywords</span>
              <div style="font-size: 0.75rem; color: #aaa">
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select
                v-model="basicForm.keywords"
                multiple
                taggable
                :options="['']"
              ></v-select>
            </div>
          </div>
        </section>
      </template>
    </section>

    <hr />

    <section>
      <!-- <h1 class="py-5">Visibility</h1>
        <div style="height: 10px"></div> -->
      <div class="pa-4">
        <span v-if="event.updated_at && event.updated_by">
          Updated by {{ event.updated_by.name }} at {{ event.updated_at }}
        </span>
        <span v-else>
          Updated at {{ event.update_date }}
        </span>
      </div>
    </section>

    <vs-divider></vs-divider>
    <div class="vx-row pt-2 mt-0">
      <div class="vx-col w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="validateForm">Save </vs-button>

        <vs-button class="mr-3 mb-2" type="border" @click="canceled"
          >Cancel
        </vs-button>
      </div>
    </div>

    <HTML-dialog
      :showDialog="htmlDialog"
      :data="selectedHTML"
      @close="htmlDialog = false"
      @submit="onHtmlDialogSubmit"
    ></HTML-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { Validator } from "vee-validate";
// import moment from "moment";
import moment from "moment-timezone";
import { mapState } from "vuex";
import Service from "@/services";

import { currencyList, protypeList } from "@/utils/Constants";
import { timezones } from "@/utils/Timezones";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import { basicForm } from "@/utils/eventForm";

import { strip_tags } from "@/utils/html";

import HTMLDialog from "@/components/soldoutt/HTMLDialog.vue";
import ArticleEditor from "@/components/ArticleEditor.vue";
import vSelect from "vue-select";

// const dict = {
//   form: {
//     name: {
//       required: "Please enter an event name",
//     },
//   },
// };

// // register custom messages
// Validator.localize("en", dict);

export default {
  components: { HTMLDialog, ArticleEditor, vSelect,draggable },
  props: {
    event: null,
    role: null,
    basicForm: basicForm,
    folder: null,
    checkRefForm: null,
    products: null,
    eventList: null
  },
  data() {
    return {
      eventFieldsPermission: eventFieldsPermission,
      timezones: timezones,
      selectedHTML: null,
      editorOption: {
        modules: {
          toolbar: "#toolbar"
        },
        placeholder: ""
      },
      editorLongOption: {
        // modules: {
        //   toolbar: "#toolbar-2",
        // },
        // placeholder: "",
        // theme: 'bubble',
        // placeholder: "",
        modules: {
          // toolbar: [
          //     ['bold', 'italic', 'underline', 'strike'],
          //     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //     [{ 'color': [] }, { 'background': [] }],
          //     [{ 'font': [] }],
          //     [{ 'align': [] }],
          //     ['link', 'image'],
          //     ['clean']
          // ]
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      introOptionOption: {
        modules: {
          // toolbar: "#toolbar-8",
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      shortdescOptionOption: {
        modules: {
          // toolbar: "#toolbar-8",
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      editorShortOption: {
        // theme: 'bubble',
        // placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      editorInstructionOption: {
        // modules: {
        //   toolbar: "#toolbar-3",
        // },
        // theme: 'bubble',
        // placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
          // toolbar: [
          //     ['bold', 'italic', 'underline', 'strike'],
          //     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //     [{ 'color': [] }, { 'background': [] }],
          //     [{ 'font': [] }],
          //     [{ 'align': [] }],
          //     ['link', 'image'],
          //     ['clean']
          // ]
        }
      },
      lobbyIntroOption: {
        // theme: 'bubble',
        // placeholder: "",
        modules: {
          // toolbar: [
          //   ['bold', 'italic', 'underline', 'strike'],
          //   [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //   [{ 'color': [] }, { 'background': [] }],
          //   [{ 'font': [] }],
          //   [{ 'align': [] }],
          //   ['link', 'image'],
          //   ['clean']
          // ]
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
        // modules: {
        //   toolbar: "#toolbar-4",
        // },
      },
      termsIntroOption: {
        formats: [
          "background",
          "bold",
          "color",
          "font",
          "code",
          "italic",
          "link",
          "size",
          "strike",
          "script",
          "underline",
          "blockquote",
          "header",
          "indent",
          "list",
          "align",
          "direction",
          "code-block",
          "image",
          "video"
        ],
        modules: {
          // toolbar: "#toolbar-5",
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      refundpolicyOption: {
        modules: {
          // toolbar: "#toolbar-9",
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      inviteTextOption: {
        modules: {
          // toolbar: "#toolbar-9",
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      taxInvoiceInstOption: {
        modules: {
          // toolbar: "#toolbar-9",
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
            ["link"] // 'image', 'video'
          ]
        }
      },
      currencyForm: {
        hasReference: false,
        currency: null,
        altcurrencycode: null,
        altcurrencyrate: null
      },
      currencyList: [],
      posterUploadUrl:
        process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
      posterUploadHeader: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
      },
      posterData: {
        type: "poster"
      },
      signatureData: {
        type: "taxinv_sign"
      },
      isEditSlug: false,
      proTypeList: [
        { text: "Tickets to events", value: "event" },
        { text: "Booths at events", value: "booth" },
        { text: "Products", value: "product" },
        { text: "Vouchers for food or services", value: "voucher" },
        { text: "Educational Courses", value: "course" },
        { text: "Online Courses", value: "onlinecourse" },
        { text: "Memberships", value: "member" }
      ],
      htmlDialog: false,
      htmlKey: null,
      isCleaned: false,
      hasRefData: 0,
      imageWidth: 0,
      imageHeight: 0,
      changeImage: false,
      acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      // checkRefForm: 0,
      posterUpdate: null,
      signature: null,
      introText: null,
      popupActivo: false,
      popupActivo2: false,
      related_product_ids_options: [],
      related_event_ids_options: [],
      related_product_ids_search: "",
      related_product_ids_input: [],
      related_event_ids_search: "",
      related_event_ids_input:[],
      keywords_input: [],
      is_event_loaded: false,
    };
  },
  watch: {
    "basicForm.taxinv_prefix"(val) {
      if (val) {
        const data = val.toUpperCase();
        this.basicForm.taxinv_prefix = data;
      }
    },
    products(val) {
      this.related_product_ids_options = val.map(item=>{
        const mapped_item = {
          label: item.pro_title,
          value: item.product_id,
          item: item,
          poster: item.poster,
        };
        return mapped_item;
      })
      this.related_product_ids_input = this.basicForm.related_product_ids ? this.basicForm.related_product_ids.split(",").map((item)=>this.related_product_ids_options.find((ep)=>ep.value==item)).filter((item)=>!!item) : []
    },
    eventList(val) {
      this.related_event_ids_options = val.map(item=>{
        const mapped_item = {
          label: item.pro_name,
          value: item.event_id,
          e: item.slug,
          poster: item.poster,
        };
        return mapped_item;
      })
      this.is_event_loaded = true
      setTimeout(()=>{
        this.related_event_ids_input = this.basicForm.related_event_ids ? this.basicForm.related_event_ids.split(",").map((item)=>this.related_event_ids_options.find((ep)=>{
          return ep.value==item
        })).filter((item)=>!!item) : []
      },300)

    },
    // 'basicform.pro_shortname'(val) {
    //   this.basicForm.pro_shortname = val
    // },
  },
  computed: {
    relatedEventSearchOptions() {
      return this.related_event_ids_options.filter((item)=> item.value != this.event.event_id &&!this.related_event_ids_input.find((ip=>ip.value == item.value)))
    },
    relatedProductSearchOptions() {
      return this.related_product_ids_options.filter((item)=>!this.related_product_ids_input.find((ip=>ip.value == item.value)))
    },
  },
  created() {
    this.currencyList = Object.keys(currencyList);
  },
  mounted() {
    this.hasReference = this.checkRefForm;
    this.setImageSize();
    const data = this.basicForm;
    this.basicForm.selldaterange = data.selldaterange;
    this.signature = this.basicForm.taxinv_sign || this.event.taxinv_sign;
    console.log(
      "this.basicForm.taxinv_sign || this.event.taxinv_sign",
      this.basicForm.taxinv_sign,
      this.event.taxinv_sign
    );

    // this.checkRefForm = this.basicForm.altcurrencycode? 1: 0
    // this.checkCurrency()
    // eslint-disable-next-line no-undef
    // ArticleEditor('#entry', {
    //     css: '/css/'
    // });
  },
  methods: {
    consolelog:console.log,
    onAddEventRelated() {
      if(!this.related_event_ids_search) {
        return;
      }
      this.related_event_ids_input.push({
          label: this.related_event_ids_search.label,
          value: this.related_event_ids_search.value,
          e: this.related_event_ids_search.e,
          poster: this.related_event_ids_search.poster,
        })
      this.related_event_ids_search = "";
    },
    onAddProductRelated() {
      if(!this.related_product_ids_search) {
        return;
      }
      this.related_product_ids_input.push({
          label: this.related_product_ids_search.label,
          value: this.related_product_ids_search.value,
          item: this.related_product_ids_search,
          poster: this.related_product_ids_search.poster,
        })
      this.related_product_ids_search = "";
    },
    removeRelatedEvent(id) {
      this.related_event_ids_input =  this.related_event_ids_input.filter(item=>item.value!=id)
    },
    removeRelatedProduct(id) {
      this.related_product_ids_input =  this.related_product_ids_input.filter(item=>item.value!=id)
    },
    validateSlug() {
      this.$vs.loading();
      Service.Event.search(this.basicForm.slug).then(res => {
        if (res.data.results.length > 0) {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : This slug already used by others.",
            color: "danger",
            fixed: true
          });
        }
        this.$vs.loading.close();
      });
    },
    splitError(val, word) {
      if (!val) {
        return;
      } else {
        const data = val.split(word);
        return data[0] + data[1];
      }
    },
    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    submitChangeSlug() {
      let data = {
        e: this.folder,
        slug: this.basicForm.slug
      };

      this.$vs.loading();

      Service.Event.updateSlug(data).then(res => {
        if (res.success) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
          this.isEditSlug = false;

          this.$router.push("/events/" + this.basicForm.slug + "/view");
        }
      });
    },
    onEditorBlur(quill) {},
    onEditorFocus(quill) {},
    onEditorReady(quill) {},
    errorPosterUpload(res) {
      this.changeImage = false;
      this.$vs.notify({
        color: "danger",
        title: "Upload Fail",
        text: "Poster upload fail!"
      });
    },
    onEditorChange({ quill, html, text }) {},
    successPosterUpload(res) {
      Service.Event.get(this.folder)
        .then(res => {
          this.event = res.data.event;
          this.event.poster = res.data.event.poster;
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        })
        .finally(() => {
          this.changeImage = false;
        });
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Poster upload success!"
      });
    },
    replaceAll(str, find, replace) {
      if (str == "" || str == null) {
        return str;
      }
      return str.replace(new RegExp(find, "g"), replace);
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submitBasic();
        } else {
          // form have errors
        }
      });
    },
    submitBasic() {
      this.basicForm.e = this.folder;

      /*CONVERT DATE FORMAT */
      this.basicForm.datetime = moment(this.basicForm.daterange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.basicForm.datetime_end = moment(this.basicForm.daterange[1]).format(
        "YYYY-MM-DD HH:mm"
      );

      // const selldaterange = [
      //   ]
      // console.log(this.basicForm.selldaterange, 'sell')

      // const sell_start = moment(this.basicForm.selldaterange[0]).tz(this.basicForm.timezone).format("YYYY-MM-DD HH:mm")
      // const sell_start = moment.tz(this.basicForm.selldaterange[0], this.basicForm.timezone)
      // const sell_end = moment(this.basicForm.selldaterange[1]).tz(this.basicForm.timezone).format("YYYY-MM-DD HH:mm")
      // const sell_end = moment.tz(this.basicForm.selldaterange[1], this.basicForm.timezone)

      // ['2022-03-21 02:00', '2031-03-21 02:00'] 'sell' // 19:00 japan

      if (this.basicForm.datetime == "Invalid date") {
        this.basicForm.datetime = moment(
          this.basicForm.daterange[0],
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }

      if (this.basicForm.datetime_end == "Invalid date") {
        this.basicForm.datetime_end = moment(
          this.basicForm.daterange[1],
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }

      // if (this.basicForm.featured_status == 0) {
      //   this.basicForm.featured_status = null;
      // }

      // if (!this.currencyForm.hasReference) {
      if (!this.basicForm.hasReference) {
        this.basicForm.altcurrencycode = null;
        this.basicForm.altcurrencyrate = null;
      }

      this.basicForm.hasReference = this.checkRefForm;
      // console.log(this.basicForm.hasReference ,'first')

      this.$vs.loading();

      let shortDesc = this.replaceAll(this.basicForm.shortdesc, "<p", "<div");
      shortDesc = this.replaceAll(shortDesc, "</p>", "</div>");

      let longDesc = this.replaceAll(this.basicForm.longdesc, "<p", "<div");
      longDesc = this.replaceAll(longDesc, "</p>", "</div>");

      let inviteText = this.replaceAll(this.basicForm.invitetext, "<p", "<div");
      inviteText = this.replaceAll(inviteText, "</p>", "</div>");

      let invInstText = this.replaceAll(
        this.basicForm.taxinv_instruction,
        "<p",
        "<div"
      );
      invInstText = this.replaceAll(invInstText, "</p>", "</div>");

      let instruction = this.replaceAll(
        this.basicForm.instruction,
        "<p",
        "<div"
      );
      instruction = this.replaceAll(instruction, "</p>", "</div>");

      let refundpolicy = this.replaceAll(
        this.basicForm.refundpolicy,
        "<p",
        "<div"
      );
      refundpolicy = this.replaceAll(refundpolicy, "</p>", "</div>");

      let lobby_intro = this.replaceAll(
        this.basicForm.lobby_intro,
        "<p",
        "<div"
      );
      lobby_intro = this.replaceAll(lobby_intro, "</p>", "</div>");

      let intro = this.replaceAll(this.basicForm.intro, "<p", "<div");
      intro = this.replaceAll(intro, "</p>", "</div>");

      //   const posterBase64 = this.posterUpdate.split(',')[1]
      const data = {
        ...this.basicForm,
        // poster: this.posterUpdate,

        pro_shortname: this.basicForm.pro_name,
        pro_title: this.basicForm.pro_name,
        pro_shortdesc: shortDesc,
        pro_longdesc: longDesc,
        instruction: instruction,
        lobby_intro: lobby_intro,
        refundpolicy:
          this.basicForm.refundpolicy === "" ? "null" : refundpolicy,
        invitetext: inviteText == null ? "null" : inviteText,
        taxinv_instruction: invInstText == null ? "null" : invInstText,
        intro: intro,
        hasReference: this.checkRefForm,
        altcurrencycode:
          this.checkRefForm === 0 ? "null" : this.basicForm.altcurrencycode,
        altcurrencyrate:
          this.checkRefForm === 0 ? "null" : this.basicForm.altcurrencyrate,
        featured_status: this.basicForm.featured_status === 1 ? 1 : 0,
        landingpage:
          this.basicForm.landingpage === ""
            ? "null"
            : this.basicForm.landingpage,
        terms: this.basicForm.terms === "" ? "null" : this.basicForm.terms,
        wht_vat:
          this.basicForm.wht_vat === "" ? "null" : this.basicForm.wht_vat,
        taxinv_supportno:
          this.basicForm.taxinv_supportno === ""
            ? "null"
            : this.basicForm.taxinv_supportno,
        taxinv_prefix:
          this.basicForm.taxinv_prefix === ""
            ? "null"
            : this.basicForm.taxinv_prefix,
        selldaterange: [
          moment(this.basicForm.selldaterange[0]).format("YYYY-MM-DD HH:mm"),
          moment(this.basicForm.selldaterange[1]).format("YYYY-MM-DD HH:mm")
        ],
        e: this.folder,
        pay_creditcard:
          this.event.pay_creditcard === null &&
          this.basicForm.pay_creditcard === 1
            ? null
            : this.basicForm.pay_creditcard,
        pay_transfer:
          this.event.pay_transfer === null && this.basicForm.pay_transfer === 1
            ? null
            : this.basicForm.pay_transfer,
        fields_status:
          this.event.fields_status === null
            ? null
            : this.basicForm.fields_status,
        related_product_ids: this.related_product_ids_input.map(item=>item.value).join(","),
        related_event_ids: this.related_event_ids_input.map(item=>item.value).join(","),
        keywords: this.basicForm.keywords.join(","),
      };

      Service.Event.update(data)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    onHTMLDialog(key, isCleaned = false) {
      this.htmlKey = key;
      this.selectedHTML = this.basicForm[key];
      this.htmlDialog = true;
      this.isCleaned = isCleaned;
    },
    onHtmlDialogSubmit(data) {
      // console.log(data);
      this.htmlDialog = false;
      if (this.isCleaned) {
        this.basicForm[this.htmlKey] = strip_tags(
          data,
          "<center><h2><h3><strong><b><i><em><a>"
        );
      } else {
        this.basicForm[this.htmlKey] = data;
      }
      this.isCleaned = false;

      this.htmlKey = null;
    },
    canceled() {
      this.$router.push(`/dash`);
    },
    removeposter() {
      this.event.poster = null;

      Service.Event.update({
        remove: "poster",
        e: this.folder
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Remove poster complete.",
              color: "success"
            });
          }
          this.popupActivo = false;
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    removeSignature() {
      this.event.taxinv_sign = null;
      this.signature = null;
      this.basicForm.taxinv_sign = null;

      Service.Event.update({
        remove: "taxinv_sign",
        e: this.folder
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Remove Siganture complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    chooseImage() {
      document.getElementById("file-upload-img").click();
    },
    chooseSignature() {
      document.getElementById("file-upload-img-signature").click();
    },
    onUploadImages() {
      this.basicForm.poster = this.$refs.fileImage.files[0];
      // this.basicForm.poster = this.$refs.fileImage.files[0]
      this.event.poster = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.event.poster = reader.result;
        this.event.has_poster = true;

        // var str = reader.result.split(',')[1]
        // var image = this.b64toBlob(str, "image/jpeg")
        // var imgURL = URL.createObjectURL(image)
        // this.posterUpdate = imgURL
        // this.basicForm.poster = reader.result
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
      this.uploadPoster(this.$refs.fileImage.files[0]);
    },
    onUploadSignature() {
      this.basicForm.taxinv_sign = this.$refs.fileImageSignature.files[0];
      // this.basicForm.poster = this.$refs.fileImageSignature.files[0]
      this.uploadPoster(this.$refs.fileImageSignature.files[0]);
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.signature = reader.result;

        // var str = reader.result.split(',')[1]
        // var image = this.b64toBlob(str, "image/jpeg")
        // var imgURL = URL.createObjectURL(image)
        // this.posterUpdate = imgURL
        // this.basicForm.poster = reader.result
      };
      reader.readAsDataURL(this.$refs.fileImageSignature.files[0]);
      this.$refs.fileImageSignature.value = null;
      this.updateSignature(this.basicForm.taxinv_sign);
    },
    uploadPoster(val) {

      if (this.event.poster != null) {
        this.$vs.loading();
        var formData = new FormData();
        formData.append("type", "poster");
        formData.append("file", this.event.poster);

        Service.Event.upload(this.folder, formData).then(res => {
          if (res.success) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
            //location.reload();
          }
        });
      } else {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
      }

    },
    updateSignature(val) {
      if (val != null) {
        this.$vs.loading();
        var formData = new FormData();
        formData.append("type", "taxinv_sign");
        formData.append("file", val);

        Service.Event.upload(this.slug, formData).then(res => {
          if (res.success) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
            //location.reload();
          }
        });
      } else {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.default-upload {
  border-radius: 8px;
}
.grid-button-upload {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, min-content);
  grid-gap: 10px;
}
.vs-button {
  font-size: 10px !important;
}
.html-btn {
  margin-top: 16px;
}
input[type="file"] {
  display: none !important;
}

.popup-confirm {
  & div {
    width: 100%;
    text-align: center;
  }
  & .wrap-button {
    display: grid;
    grid-template-columns: repeat(2, 25%);
    grid-gap: 8px;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
</style>
<style>
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: #e40813 !important;
}
.el-date-table td.available:hover {
  color: #e40813 !important;
}
.el-date-range-picker .el-picker-panel__body {
  z-index: 60000 !important;
}
.hide-select-action .vs__actions{
  display:none
}
.close-btn {
  font-size: 24px;
  position: absolute;
  right: -12px;
  top: -12px;
  cursor: pointer;
}

</style>
